import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { environmentSelector } from "Reducers/environment";
import { useAppDispatch } from "Store/hooks";

import { addVariable } from "../thunks/addVariable.thunk";

type NewProjectVariable = {
  id: string;
  name: string;
  value: any;
  is_json: boolean;
  is_sensitive: boolean;
  visible_build: boolean;
  visible_runtime: boolean;
  is_enabled: boolean;
  is_inheritable: boolean;
};

export function useAddVariable({
  organizationId,
  projectId,
  environmentId
}: {
  organizationId: string;
  projectId: string;
  environmentId: string;
}) {
  const dispatch = useAppDispatch();
  const environment = useSelectorWithUrlParams(environmentSelector);

  if (!environment) return;

  return async (data: NewProjectVariable) =>
    await dispatch(
      addVariable({
        organizationId,
        projectId,
        environmentId,
        data,
        environment
      })
    );
}
